// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gUP6","largestCol":"styles_largestCol__2zPqB","smallestCol":"styles_smallestCol__opmOk"};